import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=9c4953c4&scoped=true"
import script from "./personal.vue?vue&type=script&lang=js"
export * from "./personal.vue?vue&type=script&lang=js"
import style0 from "./personal.vue?vue&type=style&index=0&id=9c4953c4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style1 from "./personal.vue?vue&type=style&index=1&id=9c4953c4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4953c4",
  null
  
)

export default component.exports